// extracted by mini-css-extract-plugin
module.exports = {"Button":"styles_Button__wA6lE","Text":"styles_Text__iTGsA","AddButton":"styles_AddButton__3KXmu","RoundedButton":"styles_RoundedButton___OA3j"};